/* eslint-disable import/prefer-default-export */
/**
 * This file will exentually be refactored to use
 * date-fns, but for the sake of starting things off
 * we're just mapping to localDateFormatter for now
 */
import localeDateFormatter from '@/utils/locale-date-formatter';

/**
 * @param {number} timestamp
 */
export function longDate(timestamp) {
    return localeDateFormatter('long', timestamp);
}

export function formatDateWithTime(timestamp) {
  return localeDateFormatter('date-with-time', timestamp);
}
